import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'


export function Video({title, videolink}) {
return (
	<Container fluid style={{'maxWidth': '1100px'}}>
	<Row>
	<Col xs={12}>
	<Card style={{'margin':'1rem'}}>
	<Card.Header>{title}</Card.Header>
	<Card.Body   style={{'textAlign': 'left'}}>
	<img src={videolink} alt={title} />
	</Card.Body>
	</Card>
	</Col>
	</Row>
	</Container>
)
}